import type { FeatureConfig } from '@platform/client/features';

import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'tickets',
      children: [
        {
          index: true,
          lazy: () => import('./components/ticketList/TicketList'),
        },
        {
          path: ':ticketId',
          lazy: () => import('./pages/ticket-details.page'),
        },
      ],
    },
  ],
  navigation: ({ subscriptions }) => ({
    ticketsAlerts: {
      allTickets: {
        title: i18n.t('ticket:allTickets'),
        segment: '/tickets',
      },
    },
    managedDetectionResponse: {
      securityInvestigations: hasAnyRequiredProperty(
        { managedDetectionResponse: true },
        subscriptions,
        false,
      )
        ? {
            title: i18n.t('ticket:securityInvestigations'),
            segment: '/tickets?type=incident',
            isBookmark: true,
          }
        : null,
    },
  }),
} satisfies FeatureConfig;
